/**
 * Map a browser image URL or data URL to pptxgenjs addImage props.
 * Base64 data URLs must use `data`, not `path`.
 */
export function toPptImageSource(imageUrl) {
  if (!imageUrl) {
    return null;
  }

  if (imageUrl.startsWith("data:")) {
    const payload = imageUrl.slice("data:".length);
    if (!payload.includes(";base64,")) {
      return null;
    }
    return { data: payload };
  }

  return { path: imageUrl };
}
